export default "__VITE_ASSET__JXdDlBKe__"